import { Box, Stack } from "@mui/material";
import { type ReactNode } from "react";
import SwipeableViews from "react-swipeable-views";

interface SwipeableViewsWithDotsProps {
  activeStep: number;
  onChangeStep: (step: number) => void;
  children: ReactNode[];
  dotsPosition?: "bottom" | "top";
  dotsOffset?: number | string;
}

export function SwipeableViewsWithDots(props: SwipeableViewsWithDotsProps) {
  const { activeStep, onChangeStep, children, dotsPosition = "bottom", dotsOffset = 40 } = props;

  const ACTIVE_DOT_SIZE = 12;
  const INACTIVE_DOT_SIZE = 8;
  const ACTIVE_DOT_OPACITY = 1;
  const INACTIVE_DOT_OPACITY = 0.2;

  return (
    <>
      <SwipeableViews
        enableMouseEvents
        index={activeStep}
        style={{
          overflow: "hidden",
          height: "100%",
        }}
        containerStyle={{ height: "100%" }}
        onChangeIndex={onChangeStep}
      >
        {children}
      </SwipeableViews>
      <Stack
        direction="row"
        spacing={3}
        justifyContent="center"
        sx={{
          position: "fixed",
          [dotsPosition]: dotsOffset,
          left: 0,
          right: 0,
        }}
      >
        {children.map((_, index) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            sx={{
              width: activeStep === index ? ACTIVE_DOT_SIZE : INACTIVE_DOT_SIZE,
              height: activeStep === index ? ACTIVE_DOT_SIZE : INACTIVE_DOT_SIZE,
              borderRadius: "50%",
              backgroundColor: (theme) => theme.palette.primary.light,
              opacity: activeStep === index ? ACTIVE_DOT_OPACITY : INACTIVE_DOT_OPACITY,
              display: "flex",
              alignItems: "center",
              alignSelf: "center",
              transition: (theme) =>
                theme.transitions.create(["width", "height", "opacity"], {
                  duration: theme.transitions.duration.shorter,
                  easing: theme.transitions.easing.easeInOut,
                }),
            }}
          />
        ))}
      </Stack>
    </>
  );
}
